import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Project } from 'app/interfaces/project.model';
import { ProjectService } from 'app/modules/project/services/project.service';

@Injectable()
export class ProjectResolver implements Resolve<Project> {

  constructor(private service: ProjectService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Project | Observable<Project> | Promise<Project> {
    return this.service.single(route.params.id);
  }

}
